import { Grid } from 'antd';

// Keep row actions visible while the other columns scroll inside the table.
export function useActionColumn(width) {
  const screens = Grid.useBreakpoint();
  return { width: screens.sm ? width : 112, fixed: 'right', className: 'table-action-cell' };
}
